/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MdClose } from 'react-icons/md';
import AppBottomSheet from '../../../shared/components/app-bottom-sheet/AppBottomSheet';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppAlert from '../../../shared/components/app-alert/AppAlert';

function BusPaxBottomSheet({ show, pax, index, onClick, onClose }) {
  const [passenger, setPasseneger] = useState(pax);
  const [alert, setAlert] = useState(undefined);

  const handleUpdateState = (name, value) => {
    if (name === 'gender') {
      let selectedTitle = 'Mr';
      selectedTitle = value === 'M' ? 'Mr' : 'Ms';
      setPasseneger((prev) => ({
        ...prev,
        gender: value,
        title: selectedTitle,
      }));
    } else if (name === 'age') {
      const selectedAge = value.replace(/[^0-9]/g, '');
      setPasseneger((prev) => ({
        ...prev,
        [name]: selectedAge,
      }));
    } else {
      const inputValue = value.replace(/[^a-zA-Z ]/g, '');
      setPasseneger((prev) => ({
        ...prev,
        [name]: inputValue,
      }));
    }
  };

  const handleOnClose = () => {
    const maxAge = 99;
    let minAge = 6;
    if (passenger.gender === 'F') {
      minAge = 13;
    }
    if (passenger.firstname.trim() === '') {
      setAlert({
        variant: 'error',
        description: 'please enter first name',
      });
      return;
    }
    if (passenger.lastname.trim() === '') {
      setAlert({
        variant: 'error',
        description: 'please enter last name',
      });
      return;
    }
    if (passenger.gender === '') {
      setAlert({
        variant: 'error',
        description: 'please enter gender',
      });
      return;
    }
    if (passenger.age === '') {
      setAlert({
        variant: 'error',
        description: 'please enter age',
      });
      return;
    }
    if (Number(passenger.age) < minAge || Number(passenger.age) > maxAge) {
      setAlert({
        variant: 'error',
        description: `Age should be between ${minAge} & ${maxAge}`,
      });
      return;
    }
    onClick(passenger, index);
  };

  return (
    <>
      {alert && (
        <AppAlert
          variant={alert.variant}
          description={alert.description}
          onHide={() => setAlert(undefined)}
        />
      )}
      {show && (
        <AppBottomSheet height="auto" isOpen={show}>
          <div className="bus-booking-review_content_pax-details_modal">
            <div className="d-flex justify-content-between align-items-center modify-search-modal_header p-3 pb-2">
              <span>Passenger Seat: {passenger.seatnumber}</span>
              <MdClose onClick={onClose} />
            </div>
            <div className="d-flex flex-column gap-2 p-2 fs-14">
              <AppTextInput
                required
                placeholderText=""
                label="First Name"
                value={passenger.firstname}
                onChange={(e) => handleUpdateState('firstname', e.target.value)}
              />
              <AppTextInput
                required
                placeholderText=""
                label="Last Name"
                value={passenger.lastname}
                onChange={(e) => handleUpdateState('lastname', e.target.value)}
              />
              <div className="ps-1 d-flex gap-1 justify-content-between align-items-center">
                <div className="d-flex flex-column">
                  <span className="fs-10">Gender *</span>
                  <div className="d-flex justify-content-between gap-2">
                    <div
                      className={`gender-chip ${
                        passenger.gender === 'M' ? 'selected-gender-chip' : ''
                      }`}
                      onClick={() => handleUpdateState('gender', 'M')}
                    >
                      M
                    </div>
                    <div
                      className={`gender-chip ${
                        passenger.gender === 'F' ? 'selected-gender-chip' : ''
                      }`}
                      onClick={() => handleUpdateState('gender', 'F')}
                    >
                      F
                    </div>
                  </div>
                </div>
                <AppTextInput
                  required
                  placeholderText=""
                  className="flex-1"
                  label="Age"
                  value={passenger.age}
                  onChange={(e) => handleUpdateState('age', e.target.value)}
                />
              </div>
              <div className="py-1 fs-14">
                <AppButton
                  btnText="Done"
                  className="w-100"
                  onClick={handleOnClose}
                />
              </div>
            </div>
          </div>
        </AppBottomSheet>
      )}
    </>
  );
}
BusPaxBottomSheet.propTypes = {
  show: PropTypes.bool.isRequired,
  pax: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default BusPaxBottomSheet;
